import { useEffect, useState } from "react";
import { Instagram } from "lucide-react";

/**
 * Live share-card preview shown on the Pledge form. As the donor types their
 * amount, the card updates (debounced) so they can see what they'll post AFTER
 * donating. Turns hesitation into desire.
 */
export default function SharePreview({ amountDollars }) {
  // Debounce the amount so we don't hammer the backend on every keystroke
  const [debounced, setDebounced] = useState(amountDollars);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(amountDollars), 500);
    return () => clearTimeout(t);
  }, [amountDollars]);

  const dollars = Math.max(1, Math.round(parseFloat(debounced || "0") || 0));
  const amountCents = dollars * 100;
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const src = `${backendUrl}/api/share-card/preview.png?type=pledge&amount=${amountCents}`;

  return (
    <div className="border border-bdu-gold/20 bg-bdu-obsidian/40 p-5 sm:p-6" data-testid="share-preview">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div>
          <div className="label-eyebrow inline-flex items-center gap-1.5" style={{ fontSize: "0.6rem" }}>
            <Instagram size={11} /> Your share card
          </div>
          <div className="mt-2 text-sm text-bdu-cream/80 font-serif italic">
            This is what you'll post after donating.
          </div>
          <p className="mt-1 text-xs text-bdu-cream/50 max-w-xs">
            Every 3 people who see it, one joins the fund. Type your amount ↑ to preview.
          </p>
        </div>
        <div className="w-28 sm:w-36 shrink-0 border border-bdu-gold/30 bg-black">
          <img
            key={amountCents}
            src={src}
            alt={`Share card preview — $${dollars}`}
            className="w-full h-auto block"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  );
}
